import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CtbCtaService, GralMonDto, CtbCtaDto, PageBusquedaObject, SatCtaCtbDto, CtbTipoDto } from '../ctb-cta.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
import { CtbCcService } from '../../ctb-cc/ctb-cc.service';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-new-cta',
  templateUrl: './formulario-ctb-cta.component.html',
  styleUrls: ['./formulario-ctb-cta.component.css'],
  preserveWhitespaces: true
})
export class FormularioCtbCtaComponent implements OnInit {
  public sinMenu: boolean = false;
  ultima_cuenta_creada: String = '';
  cargado = false;
  monedas: any = [];
  tipoCuenta: any = [];
  estructura: any[] = [];
  maxLengthCuenta: number;
  claveSats: SatCtaCtbDto[] = [];
  public id_param = null;
  cuentasPadre: CtbCtaDto[] = [];
  public dto: CtbCtaDto = new CtbCtaDto();
  centrosCostos: any[] = [];
  busquedaCuentasPadres: PageBusquedaObject = new PageBusquedaObject();
  busquedaSat: PageBusquedaObject = new PageBusquedaObject();

  searchCuenta$ = new Subject<string>();

  constructor(private router: Router, private service: CtbCtaService,
    private activatedRoute: ActivatedRoute, public loginService: LoginService, private ctbCcService: CtbCcService) {
    this.estructura = this.loginService.usuario.empresa_seleccionada.estructura1.split('-');
    this.maxLengthCuenta = this.loginService.usuario.empresa_seleccionada.estructura1.length;
  }

  ngOnInit() {

    this.searchCuenta$
      .pipe(debounceTime(0), distinctUntilChanged())
      .subscribe(term => this.ctb_cta_catalogo(term));
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['sinMenu'] !== undefined) {
        this.sinMenu = params['sinMenu'] === 'true' || params['sinMenu'] === true;
      }
    });
    this.cargado = true;
    this.cargarTiposCuenta();
    this.cargarMonedas();
    this.dto.cuentaPadre = new CtbCtaDto();
    this.dto.satCtaCtb = new SatCtaCtbDto();
    this.busquedaCuentasPadres.criteriaSearch = {};
    this.busquedaCuentasPadres.itemsPerPage = 5;
    this.busquedaCuentasPadres.pageNumber = 0;
    this.busquedaCuentasPadres.order = 'ASC';
    this.busquedaCuentasPadres.sort = true;
    this.busquedaCuentasPadres.column = 'cuenta';
    this.busquedaSat.criteriaSearch = {};
    this.busquedaSat.itemsPerPage = 5;
    this.busquedaSat.pageNumber = 0;
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.getById(this.id_param);
      }
    });
  }

  getById(id: number) {
    this.service.getCta(id).subscribe(response => {
      this.dto = response.contenido;

      if (this.dto.tipo == undefined) {
        this.dto.tipo = this.tipoCuenta[0].id;
      }
      if (this.dto.cuentaPadre == null) {
        this.dto.cuentaPadre = new CtbCtaDto();
      }
      if (this.dto.satCtaCtb == null) {
        this.dto.satCtaCtb = new SatCtaCtbDto();
      }
      this.ctb_cta_catalogo(this.dto.cuentaPadre.cuenta);
      this.cargarClaveSats(this.dto.satCtaCtb.clave);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }

  asignarEstructura() {
    if (!this.dto.cuenta) return;

    // 1️⃣ Quitar todos los guiones
    const cuentaLimpia = this.dto.cuenta.replace(/-/g, '');

    let resultado = '';
    let indice = 0;

    // 2️⃣ Reconstruir según estructura
    for (let i = 0; i < this.estructura.length; i++) {
      const longitud = Number(this.estructura[i].length);
      const segmento = cuentaLimpia.substring(indice, indice + longitud);

      if (!segmento) break;

      resultado += segmento;
      indice += segmento.length;

      // 3️⃣ Agregar guion solo si no es el último segmento
      if (
        segmento.length === longitud &&
        indice < cuentaLimpia.length &&
        resultado.length < this.maxLengthCuenta
      ) {
        resultado += '-';
      }
    }

    this.dto.cuenta = resultado;
  }



  cargarCentroCostos(codigo: string, titulo: string) {
    if (codigo == '') {
      codigo = 'na';
    }
    if (titulo == '') {
      titulo = 'na';
    }
    this.ctbCcService.getAutocompletado(codigo, titulo, this.loginService.empresa).subscribe(response => {
      this.centrosCostos = response.contenido;

      if (this.centrosCostos.length == 1 &&
        (this.centrosCostos[0].titulo == titulo || this.centrosCostos[0].codigo == codigo)) {
        this.dto.ctbCC.id = this.centrosCostos[0].id;
        if (codigo == 'na') {
          this.dto.ctbCC.titulo = this.centrosCostos[0].titulo;
        }
        if (titulo == 'na') {
          this.dto.ctbCC.codigo = this.centrosCostos[0].codigo;
        }
      }

    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });

  }
  cargarMonedas() {
    this.service.getMonByEmpId(this.loginService.empresa).subscribe(response => {
      this.monedas = response.contenido;
      if (!this.monedas || this.monedas.length == 0) {
        Swal.fire({
          title: 'Error',
          text: `No existen monedas registradas`,
          allowOutsideClick: false,
          confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/contabilidad/catalogo/ctb-cta']);
          }
        });
      } else {
        if (!this.id_param) {
          this.dto.gralMonId = this.monedas[0].id;
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cargarTiposCuenta() {
    this.service.getTipo().subscribe(response => {
      this.tipoCuenta = response.contenido;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
      console.log(err);
    });
  }
  crear() {
    this.dto.gralUsrCreaId = this.loginService.usuario.id as number;
    this.dto.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.dto.gralUsrBajaId = this.loginService.usuario.id as number;
    this.dto.gralSucId = this.loginService.sucursal as number;
    this.dto.gralEmpId = this.loginService.empresa as number;
    this.service.postTpol(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/ctb-cta']);
    }, err => {
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  actualizar() {
    this.dto.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.service.putTpol(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      if (this.sinMenu) {

        this.cerrarVentana();
      } else {
        this.router.navigate(['/contabilidad/catalogo/ctb-cta']);
      }
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  aplicar_herencia(event: any) {
    const id = event!= null? event.id : null;
    console.log("Aplicando herencia de cuenta padre");

    console.log(id);
    if (id === null) {
      this.dto.cuentaPadre = new CtbCtaDto();
      this.dto.clasificacion = 1;
      return;
    }
    const cuentaPadreSeleccionada = this.cuentasPadre.find(cuenta => cuenta.id === id);
    this.dto.cuentaPadre = cuentaPadreSeleccionada!;

    if (cuentaPadreSeleccionada && cuentaPadreSeleccionada.id) {
      if (cuentaPadreSeleccionada.clasificacion == 4) {
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: 'No se puede seleccionar una cuenta afectable como cuenta padre'
        });
        this.dto.cuentaPadre = new CtbCtaDto();
        this.cuentasPadre = [];
        return;
      }
      this.dto.naturaleza = cuentaPadreSeleccionada.naturaleza;
      this.dto.clasificacion = cuentaPadreSeleccionada.clasificacion + 1;

      this.dto.tipo = cuentaPadreSeleccionada.tipo;
      this.dto.gralMonId = cuentaPadreSeleccionada.gralMonId;
    } 
  }
  ctb_cta_catalogo(cuenta_nombre: string) {

    this.busquedaCuentasPadres.criteriaSearch['cuenta_nombre'] = cuenta_nombre;
    this.busquedaCuentasPadres.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuentasPadres.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.ctaCatalogo(this.busquedaCuentasPadres).subscribe(response => {
      this.cuentasPadre = response.contenido.content.map((item: any) => ({
        ...item,
        cuenta_nombre: `${item.cuenta} - ${item.nombre}`
      })).filter((item: any) => item.id !== this.dto.id);
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cargarClaveSats(clave_descripcion: string) {

        this.busquedaCuentasPadres.criteriaSearch['clave_descripcion'] = clave_descripcion;
    this.busquedaCuentasPadres.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuentasPadres.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.getSat(this.busquedaCuentasPadres).subscribe(response => {
      this.claveSats = response.contenido.map((item: any) => ({
        ...item,
        clave_descripcion: `${item.clave} - ${item.descripcion}`
      }))
    }, err => {
      console.log(err);
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
    });
    this.claveSats = [];
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }


  cerrarVentana() {
    window.close();
  }
}
